import type { TLockersResponse } from "../models/lockers";
import type { TMapLocker } from "../types";

const mapLockersResponse = (response: TLockersResponse): TMapLocker[] =>
  (response || []).map((locker) => ({
    id: locker.id,
    name: locker.name,
    lat: parseFloat(locker.address.latLong[0]!),
    lng: parseFloat(locker.address.latLong[1]!),
  }));

export default mapLockersResponse;
